<template>
  <!-- Account View -->
  <MainLayout>
    <!-- Toolbar -->
    <template #toolbar />
    <template #content>
      <AuthExtModal />
    </template>
  </MainLayout>
</template>

<script>
import AuthExtModal from '../../components/sidebar/AuthExtModal.vue'
import MainLayout from '../../layouts/MainLayout'

export default {
  name: 'ChromeExtensionAuthView',
  components: { MainLayout, AuthExtModal }
}
</script>

<style scoped lang="sass"></style>
